import { render } from "./HeaderSearch.vue?vue&type=template&id=987b0be4&scoped=true"
import script from "./HeaderSearch.vue?vue&type=script&lang=js"
export * from "./HeaderSearch.vue?vue&type=script&lang=js"

import "./HeaderSearch.vue?vue&type=style&index=0&id=987b0be4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987b0be4"]])

export default __exports__